/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Select_ViewInputs */

const en_calendar_select_view = /** @type {(inputs: Calendar_Select_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select view`)
};

const pt_br2_calendar_select_view = /** @type {(inputs: Calendar_Select_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar visualização`)
};

/**
* | output |
* | --- |
* | "Select view" |
*
* @param {Calendar_Select_ViewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_select_view = /** @type {((inputs?: Calendar_Select_ViewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Select_ViewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_select_view(inputs)
	return pt_br2_calendar_select_view(inputs)
});